import moment from 'moment';
import { FC, useState } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../../shared/dialog/dialog.styles';
import { withPatientIvStatusDialogProvider } from '../../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../../shared/appointment-ended-message/appointment-ended-message';
import { InsuranceInfo } from '../../shared/insurance-info/insurance-info';
import { ManuallyVerifiedButton } from '../../shared/manually-verified-button';
import { RunVerificationButton } from '../../shared/run-verification-button';
import { SelfPayButton } from '../../shared/self-pay-button';
import { BoldText } from '../../styles';

const NotRegisteredWithPayerStatusDialog: FC = (props) => {
  const { opened, onClose, isLoading, patientInfo, selectedIvSummary, getProvider, appointment } =
    usePatientIvStatusDialog();
  const [provider] = useState(getProvider(selectedIvSummary?.idProvider));

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Needs Attention"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateReceived && (
            <>&nbsp;- Run {moment.utc(selectedIvSummary?.dateReceived).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '10px 0 20px 0', display: 'block' }}>
        {provider ? provider.name : 'Current Provider'} isn't a registered with payer{' '}
        {selectedIvSummary?.idPayer || 'Unknown Payer'} or is tied to the wrong NPI.
        <br />
        <br />
        Please correct the issue to rerun the verification process. Alternatively, you may manually verify the patient
        or designate them as self-pay.
      </DialogSubTitle>
      <br />
      {patientInfo && <InsuranceInfo patientInfo={patientInfo} />}
      <AppointmentEndedMessage />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <RunVerificationButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(NotRegisteredWithPayerStatusDialog);
